module.exports = __webpack_public_path__ + "static/media/premium.2dde7d49.svg";